import * as React from 'react';
import { Alert, AlertTitle, Backdrop } from '@mui/material';

interface ErrorOverlayProps {
  title?: string | null;
  message?: string;
}

function ErrorOverlay({ title, message }: ErrorOverlayProps) {
  return (
    <Backdrop
      open
      sx={{
        opacity: 0,
        backgroundColor: 'transparent',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Alert severity="error">
        <AlertTitle>{title ?? 'Error'}</AlertTitle>
        {message ?? null}
      </Alert>
    </Backdrop>
  );
}

export default ErrorOverlay;
